import { UserMultiValue } from '../../../User'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import * as styles from './TableUserCell.module.css'

function TableUserCell({
  Content,
  avatarSize = 24,
  children,
  done,
  unread,
  value,
  ...cellProps
}) {
  return value ? (
    <TableCellBase {...cellProps}>
      <UserMultiValue
        {...value}
        Content={Content}
        avatarSize={avatarSize}
        className={styles.userValue}
        done={done}
        unread={unread}
      >
        {children}
      </UserMultiValue>
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableUserCell
